module.exports = __webpack_public_path__ + "static/img/ezn-foundation-thumb.661a40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/ezn-foundation-thumb.jpg
// module id = Kau6
// module chunks = 0